/**
 * Super Admin "view as" landing on the customer portal: `/view-as#code=...` (docs/specs/staff-view-as.md).
 * Standalone (AuthLayout, no shell) and public: it creates the session, so it must work signed out.
 */
import { ViewAsRedeem } from '../../../shell/ViewAs';

export function ViewAsPage() {
  return <ViewAsRedeem surface="customer" />;
}
